export enum VatSensorTypes {
	RADAR = 'radarDistance',
	LIDAR = 'lidarDistance',
	VAT_TEMP = 'vatTemp',
	INLET_TEMP = 'inletTemp',
	STIRRER = 'stirrer',
}
